const tiles = document.querySelectorAll('.js-container-link');

const init = function() {
  if ( tiles.length ) {
    tiles.forEach( tile => {
      
      const linkElement = tile.querySelector('a')

      if ( !linkElement ) return

      const href = linkElement.hasAttribute('href') ? linkElement.getAttribute('href') : null

      if ( !href ) return

      if ( href ) {
        tile.classList.add('has-hover')
        tile.addEventListener( 'click', () => {
          linkElement.click()
        } )
      }

    } );
  }
};

const api = {
	init: init
};

export default api;